import {
  lazy, Suspense, useEffect, useState,
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import css from './index.module.css';
import axiosWrapper from '../../services/axiosWrapper';

const SignupForm = lazy(() => import('../SignUpForm'));
const SignInTemplate = lazy(() => import('../SignInTemplate'));
const ForgotPassword = lazy(() => import('../ForgotPassword'));
const ResetPassword = lazy(() => import('../ResetPassword/ResetPassword'));

const SignInForm = ({ formType = 'signin' }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showFormType, setShowFormType] = useState(formType);
  const [showSignInImage, setShowSignInImage] = useState(true);
  const [renderForm, setRenderForm] = useState(false);
  const layout = useSelector((state) => state.layout);
  const [signInShow2FA, setSignInShow2FA] = useState(false);

  const openSignupDialog = () => {
    window.open('https://cube.ms/trial', '_blank');
    // Temporarily blocking the signup
    // setShowFormType('signup');
  };

  const handleForgotPassword = () => {
    setShowFormType('forgot');
  };

  const openSigninDialog = () => {
    setShowFormType('signin');
  };

  const handleSignClick = () => {
    setShowFormType('signin');
    navigate('/');
  };

  const handleAdfsSsoClick = () => {
    axiosWrapper
      .get(`${process.env.REACT_APP_CUBE_BACKEND}/accounts/getSsoStrategy`)
      .then((res) => {
        if (res.data.status && res.data.strategy != 'local') {
          window.location.href = `${process.env.REACT_APP_CUBE_BACKEND}/accounts/redirectToSsoStrategy`;
        } else {
          setRenderForm(true);
        }
      })
      .catch((e) => { });
  };

  useEffect(() => {
    if (location.pathname == '/resetPassword') {
      setRenderForm(true);
      setShowFormType('reset');
    }
    else if (location.pathname == '/signup' || location.pathname == '/95789') {
      setRenderForm(true);
    }
  }, [location.pathname]);

  const redirectToHomePage = () => {
    const searchParams = new URLSearchParams(location.search);
    let redirectUrl = layout.DEFAULT_LANDING_PAGE;

    // TODO: Case for superadmin as layout api throws error
    if (!layout.DEFAULT_LANDING_PAGE) {
      redirectUrl = '/dashboard';
    }

    if (searchParams.get('redirectUrl')) {
      redirectUrl = decodeURIComponent(searchParams.get('redirectUrl'));

      try {
        const url = new URL(redirectUrl);
        if (url.origin == process.env.REACT_APP_CUBE_BACKEND) {
          window.location.href = redirectUrl;
        }
      }
      catch (e) {
        navigate(redirectUrl);
      }
    }
    else {
      navigate(redirectUrl);
    }
  };

  const init = async () => {
    // patch for jwtToken saved in cookie for sso  - saml
    const checkIfAuthenticated = await axiosWrapper.get(`${process.env.REACT_APP_CUBE_BACKEND}/accounts/checkIfAuthenticated`, {
      withCredentials: true,
    });
    if (checkIfAuthenticated.data.status) {
      localStorage.setItem('isLogedIn', true);
      redirectToHomePage();
    } else if (checkIfAuthenticated.data.status && checkIfAuthenticated.data.authError) {
      alert(checkIfAuthenticated.data.authError);
    } else if (location.pathname == '/' && !checkIfAuthenticated.data.status) {
      handleAdfsSsoClick();

      if (checkIfAuthenticated.data.errorCode == 7004) {
        setSignInShow2FA(true);
      }
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      {renderForm ? (
        <>
          <div className={css.root}>
            <div className={`${css.leftSection} ${css.signupSection}`}>
              <div className={css.bodyWrapper}>
                {/* <div className={css.body}> */}
                {showFormType == 'reset' && (
                  <Suspense fallback={<></>}>
                    <ResetPassword handleSignClick={handleSignClick} />
                  </Suspense>
                )}

                {showFormType == 'signup' && (
                  <Suspense fallback={<></>}>
                    <SignupForm setShowSignInImage={setShowSignInImage} />
                  </Suspense>
                )}

                {showFormType == 'forgot' && (
                  <Suspense fallback={<></>}>
                    <ForgotPassword handleSignClick={handleSignClick} />
                  </Suspense>
                )}

                {showFormType == 'signin' && (
                  <Suspense fallback={<></>}>
                    <SignInTemplate
                      redirectToHomePage={redirectToHomePage}
                      openSignupDialog={openSignupDialog}
                      handleForgotPassword={handleForgotPassword}
                      signInShow2FA={signInShow2FA}
                    />
                  </Suspense>
                )}
                {/* </div> */}
              </div>
            </div>
            {showSignInImage && (
              <div className={css.rightSection}>
                <img className={css.rightImage} src={`${process.env.REACT_APP_IMAGES_PUBLIC_URL}${layout.SIGNIN_INFO_LOGO}`} />
              </div>
            )}
          </div>
        </>
      ) : null}
    </>
  );
};

export default SignInForm;
